const decodeSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

const toSegments = (path: string): string[] => path.split("/").filter(Boolean);

export const resolvePublicPrefix = ({
  browserPath,
  requestPath,
}: {
  browserPath: string;
  requestPath: string | null;
}): string => {
  if (!requestPath) return "";

  const browserSegments = toSegments(browserPath);
  const requestSegments = toSegments(requestPath);
  const prefixLength = browserSegments.length - requestSegments.length;

  if (prefixLength <= 0) return "";

  const endsWithRequestPath = requestSegments.every(
    (segment, index) => decodeSegment(segment) === decodeSegment(browserSegments[prefixLength + index]),
  );

  if (!endsWithRequestPath) return "";

  return `/${browserSegments.slice(0, prefixLength).join("/")}`;
};

export const toPathname = ({ url }: { url: string }): string => {
  const [path] = url.split(/[?#]/);
  return path || "/";
};
